import { render, staticRenderFns } from "./DepositSlipTemplate.vue?vue&type=template&id=35b457a4&scoped=true"
import script from "./DepositSlipTemplate.vue?vue&type=script&lang=js"
export * from "./DepositSlipTemplate.vue?vue&type=script&lang=js"
import style0 from "./DepositSlipTemplate.vue?vue&type=style&index=0&id=35b457a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b457a4",
  null
  
)

export default component.exports